import React from 'react';
import {
	PARAGRAPH_KEY,
	HEADING_KEY,
} from '@techchange/pm-specs';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import { useIntl } from 'react-intl';
import {
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	UncontrolledDropdown
} from 'reactstrap';

import { messages } from '../../../../../../_shared/i18n/messages';

import getActiveTypography from '../../utils/getActiveTypography';
import { toggleHeading } from '../commands';

import './HeadingDropdown.scss';

const propTypes = {

	/*
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView)

};

const HeadingDropdown = ({ editorView }) => {

	const intl = useIntl();

	const { schema } = editorView.state;

	const handleOnToggle = (nodeKey, attrs) => {

		toggleHeading(nodeKey, attrs)(editorView.state, editorView.dispatch);
		editorView.focus();

	};

	// Determine which typographical elements are within the current selection
	const headingNodeType = schema.nodes[HEADING_KEY];
	const paragraphNodeType = schema.nodes[PARAGRAPH_KEY];

	const activeTypography = getActiveTypography(editorView.state);

	const paragraphActive = activeTypography.length === 1 &&
		activeTypography[0].type === paragraphNodeType;

	const headingOneActive = activeTypography.length === 1 &&
		activeTypography[0].type === headingNodeType && activeTypography[0].attrs.level === 1;

	const headingTwoActive = activeTypography.length === 1 &&
		activeTypography[0].type === headingNodeType && activeTypography[0].attrs.level === 2;

	const headingThreeActive = activeTypography.length === 1 &&
		activeTypography[0].type === headingNodeType && activeTypography[0].attrs.level === 3;

	let dropdownLabel;

	if (paragraphActive) {

		dropdownLabel =
			intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_NORMAL_TEXT);

	} else if (headingOneActive) {

		dropdownLabel =
			intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_ONE);

	} else if (headingTwoActive) {

		dropdownLabel =
			intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_TWO);

	} else if (headingThreeActive) {

		dropdownLabel =
			intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_THREE);

	}

	return (
		<div className="heading-dropdown">
			<UncontrolledDropdown>
				<DropdownToggle caret>
					{dropdownLabel}
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem
						active={paragraphActive}
						onClick={() => handleOnToggle(PARAGRAPH_KEY)}>
						<p>
							{intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_NORMAL_TEXT)}
						</p>
					</DropdownItem>
					<DropdownItem
						active={headingOneActive}
						onClick={() => handleOnToggle(HEADING_KEY, { level: 1 })}>
						<h1>
							{intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_ONE)}
						</h1>
					</DropdownItem>
					<DropdownItem
						active={headingTwoActive}
						onClick={() => handleOnToggle(HEADING_KEY, { level: 2 })}>
						<h2>
							{intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_TWO)}
						</h2>
					</DropdownItem>
					<DropdownItem
						active={headingThreeActive}
						onClick={() => handleOnToggle(HEADING_KEY, { level: 3 })}>
						<h3>
							{intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_HEADING_LABEL_HEADING_THREE)}
						</h3>
					</DropdownItem>
				</DropdownMenu>
			</UncontrolledDropdown>
		</div>
	);

};

HeadingDropdown.propTypes = propTypes;

export default HeadingDropdown;
